document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-gift-add]');
  if (!button) return;

  event.preventDefault();
  if (button.disabled) return;

  const wrapper = document.getElementById('CartDrawer-GiftWrapper');
  if (!wrapper) return;

  const giftVariant1 = wrapper.dataset.giftVariant1;
  const giftVariant2 = wrapper.dataset.giftVariant2;
  const clickedVariantId = button.dataset.variantId;
  const otherVariantId = clickedVariantId === giftVariant1 ? giftVariant2 : giftVariant1;

  button.disabled = true;
  button.textContent = 'Adding...';

  fetch('/cart.js')
    .then((res) => res.json())
    .then((cart) => {
      const otherItem = cart.items.find((item) => String(item.variant_id) === String(otherVariantId));

      if (otherItem) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: otherItem.key, quantity: 0 })
        });
      }
      return Promise.resolve();
    })
    .then(() => {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: clickedVariantId, quantity: 1 }] })
      });
    })
    .then((res) => res.json())
    .then((result) => {
      if (result.status) {
        console.error('Add to cart error:', result);
        button.disabled = false;
        button.textContent = 'Add to Cart';
        return;
      }
      return fetch('/?section_id=cart-drawer');
    })
    .then((res) => {
      if (!res) return;
      return res.text();
    })
    .then((html) => {
      if (!html) return;
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const newDrawerInner = parsedHtml.querySelector('#CartDrawer');
      const currentDrawerInner = document.getElementById('CartDrawer');
      if (newDrawerInner && currentDrawerInner) {
        currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
      }

      fetch('/?section_id=cart-icon-bubble')
        .then((res) => res.text())
        .then((bubbleHtml) => {
          const parsedBubble = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          const newBubble = parsedBubble.querySelector('.shopify-section');
          const currentBubble = document.getElementById('cart-icon-bubble');
          if (newBubble && currentBubble) {
            currentBubble.innerHTML = newBubble.innerHTML;
          }
        });
    })
    .catch((err) => {
      console.error('Gift add error:', err);
      button.disabled = false;
      button.textContent = 'Add to Cart';
    });
});